import React from "react";
import Lottie from "react-lottie-player";

import LoaderWhite from "../../assets/gifs/loaderWhite.json";
import LoaderBlue from "../../assets/gifs/loaderBlue.json";

const Loader = (props) => {
	return (
		<Lottie
			id="loader"
			loop
			animationData={props.type === "primary" ? LoaderBlue : LoaderWhite}
			play
			className={props.className ? props.className : ""}
			style={{
				minWidth: `${props.height}px`,
				maxWidth: `${props.height}px`,
				minHeight: `${props.height}px`,
				maxHeight: `${props.height}px`,
				...props.styles,
			}}
		/>
	);
};

export default Loader;
